import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "react-feather";
import "./index.scss";

const AccordionSection = (props) => {

  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(!!props.expanded || false);
  const [parentChecked, setParentChecked] = useState(false);
  const contentRef = useRef(null);
  const isSyncingRef = useRef(false);

  useEffect(() => {
    setExpanded(props.expanded);
  }, [props.expanded]);

  // Remove automatic syncing of children on parentChecked change.

  useEffect(() => {
    if (!props.geodataDownload) return;
    if (!contentRef.current) return;
    const node = contentRef.current;
    const handleChange = (e) => {
      if (isSyncingRef.current) return;
      if (!node) return;
      const target = e.target;
      if (!target || target.type !== "checkbox") return;
      const checkboxes = node.querySelectorAll('input[type="checkbox"]');
      if (checkboxes.length === 0) return; // no children; don't override header state
      const allChecked = Array.from(checkboxes).every((cb) => cb.checked);
      setParentChecked(allChecked);
    };
    node.addEventListener("change", handleChange, true);
    return () => {
      if (node) node.removeEventListener("change", handleChange, true);
    };
  }, [props.geodataDownload]);

  useEffect(() => {
    if (!props.geodataDownload) return;
    if (!contentRef.current) return;
    const checkboxes = contentRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    if (checkboxes.length === 0) return; // keep current header state for empty accordions
    const allChecked = Array.from(checkboxes).every((cb) => cb.checked);
    setParentChecked(allChecked);
  }, [expanded, props.geodataDownload]);

  useEffect(() => {
    if (!props.geodataDownload) return;
    const handleGlobalSelectAll = (e) => {
      if (!e || !e.detail || typeof e.detail.checked !== "boolean") return;
      setParentChecked(e.detail.checked);
    };
    window.addEventListener("geodata-select-all", handleGlobalSelectAll);
    return () => {
      window.removeEventListener("geodata-select-all", handleGlobalSelectAll);
    };
  }, [props.geodataDownload]);

  const Icon = (icon) => {
    const IconComponent = icon;
    return icon ? <IconComponent /> : null;
  };
  return (
    <div
      className={`${!props.buildingGroup ? "accordion-section" : ""}
    ${props.buildingGroup ? "building-accordion-section" : ""}
    `}
      style={props.style}
    >
      <button
        className={`
        ${
          !props.buildingGroup
            ? "accordion-section_btn accordion-section__header"
            : ""
        }
        ${
          props.buildingGroup
            ? "building-accordion-section_btn building-accordion-section__header"
            : ""
        }
      ${
        expanded && props.buildingGroup
          ? "building-accordion-section_btn--expanded"
          : ""
      }
      `}
        onClick={() => setExpanded(!expanded)}
      >
        {props.showHeaderCheckbox && (
          <div style={{ display: "flex" }}>
            <input
              type="checkbox"
              style={{ width: "12px", marginRight: "6px" }}
              checked={props.headerCheckboxChecked || false}
              disabled={props.headerCheckboxDisabled || false}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                if (props.onHeaderCheckboxChange && !props.headerCheckboxDisabled) {
                  props.onHeaderCheckboxChange(e.target.checked);
                }
              }}
            />
            <span
              style={{
                opacity: props.headerCheckboxDisabled ? 0.5 : 1,
                cursor: props.headerCheckboxDisabled ? "not-allowed" : "default",
              }}
            >
              {t("SelectSection")}
            </span>
          </div>
        )}
        {Icon(props.icon)}
        <span className={`${props.buildingGroup ? "building-span" : ""}`}>
          {props.title}
        </span>
        <div style={{ display: "flex" }}>
          {props.geodataDownload && (
            <input
              type="checkbox"
              style={{ width: "12px" }}
              checked={parentChecked}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                const checked = e.target.checked;
                setParentChecked(checked);
                if (!contentRef.current) return;
                const checkboxes = contentRef.current.querySelectorAll(
                  'input[type="checkbox"]'
                );
                isSyncingRef.current = true;
                checkboxes.forEach((cb) => {
                  cb.checked = checked;
                  const event = new Event("change", { bubbles: true });
                  cb.dispatchEvent(event);
                });
                isSyncingRef.current = false;
              }}
            />
          )}
          <ChevronRight
            className={`
          ${!props.buildingGroup ? "accordion-section__chevron" : ""}
          ${
            !props.buildingGroup && expanded
              ? " accordion-section__chevron--expanded"
              : ""
          }${
              props.buildingGroup && expanded
                ? "building-accordion-section__chevron--expanded"
                : ""
            }
          ${props.buildingGroup ? "building-accordion-section__chevron" : ""}
          `}
            size={"18px"}
          />
        </div>
      </button>
      <div
        className={`
        ${!props.buildingGroup ? "accordion-section__content" : ""}
        ${
          !props.buildingGroup && expanded
            ? " accordion-section__content--expanded"
            : ""
        }
        ${
          props.buildingGroup && expanded
            ? "building-accordion-section__content--expanded"
            : ""
        }
        ${
          props.buildingGroup && !expanded
            ? "building-accordion-section__content"
            : ""
        }
        `}
        ref={contentRef}
      >
        {props.children}
      </div>
    </div>
  );
};

export default AccordionSection;
